import messages from './messages';

import { getBrandName } from '../../Base/i18n/brand';


export const suggestionsContent = [
  {
    message: { ...messages.errorNotFoundFindAndRent },
    label: { ...messages.errorNotFoundFindAndRentLabel,
      values: {
        companyName: getBrandName(),
      } },
    link: messages.errorNotFoundFindAndRentLink,
  },
  {
    message: { ...messages.errorNotFoundPublish },
    label: { ...messages.errorNotFoundPublishLabel },
    link: messages.errorNotFoundPublishLink,
  },
  {
    message: { ...messages.errorNotFoundRecommend },
    label: { ...messages.errorNotFoundRecommendLabel },
    link: messages.errorNotFoundRecommendLink,
  },
  {
    message: { ...messages.errorNotFoundRealtor },
    label: { ...messages.errorNotFoundRealtorLabel },
    link: messages.errorNotFoundRealtorLink,
  },
  {
    message: { ...messages.errorNotFoundAbout,
      values: {
        companyName: getBrandName(),
      } },
    label: { ...messages.errorNotFoundAboutLabel,
      values: {
        companyName: getBrandName(),
      } },
    link: messages.errorNotFoundAboutLink,
  },
];
